/**
 * FireFlyVnextHelpers.js
 *
 * Utility functions for sending analytics events to Firefly via EventAPI.
 *
 * Usage:
 * - Use `handleFireflySendEvent` to send general events.
 *   - `eventId` is optional. If provided, it will be included in the event payload.
 *   - All parameters are strictly checked; refer to the EventAPI documentation for required types.
 * - Use `handleFireflySendClickEvent` to send click events.
 *
 * For more details on EventAPI options and strict type requirements, see:
 * https://praxis-framework.prod.target.com/observability/analytics#eventapioptions
 *
 */

import { EventAPI } from '@praxis/analytics'
import apiConfig from '../../config/apiConfig'

const fireflyConfig = {
  apiKey: apiConfig.auth.apiKey,
  appName: 'ZIPTIE',
  retries: apiConfig.firefly.retries,
  url: apiConfig.firefly.url,
}

const eventAPI = new EventAPI(fireflyConfig)

const getClientInfo = (userInfo, pageName = '') => ({
  employee_login_id: userInfo.email || '',
  page_name: pageName,
  page_url: window.location.href,
  user_agent: navigator.userAgent,
  user_id: userInfo.lanId,
  version: process.env.APP_VERSION,
})

export const handleFireflySendEvent = (
  eventType,
  pageName,
  taskName,
  userInfo,
  eventId, // optional
) => {
  const client = { ...getClientInfo(userInfo, pageName) }
  eventAPI.sendEvent({
    client,
    event: {
      ...(eventId ? { id: eventId } : {}),
      type: eventType,
      value: taskName,
    },
  })
}

export const handleFireflySendClickEvent = (
  eventId,
  pageName,
  taskName,
  userInfo,
) => {
  const client = { ...getClientInfo(userInfo, pageName) }
  eventAPI.sendClickEvent(eventId, {
    client,
    event: {
      id: eventId,
      value: taskName,
    },
  })
}
